import { Spinner } from "@blueprintjs/core"
import { colors } from "@src/theme"
import styled from "styled-components"

export const SpinnerStyled = styled(Spinner)`
  .bp5-spinner-head {
    stroke: ${colors.gray10};
  }
`
